import { Modal as ModalWrapper } from '@mui/material';
import { FC } from 'react';

import { useActions } from '../../hooks/useActions';
import { useBasket } from '../../hooks/useBasket';

import './BasketDialog.sass';
import { AddShippingAddress } from './form/AddShippingAddress';

//Модальное окно "Куда доставить заказ"
export const BasketDialog: FC = () => {
  const { setVisibleBasketDialog } = useActions();
  const { visibleBasketDialog } = useBasket();
  // Закрыть окно организации
  const handleClose = () => setVisibleBasketDialog(!visibleBasketDialog);
  const handleOpenAddAddressModal = () =>
    setVisibleBasketDialog(!visibleBasketDialog);
  return (
    <div className="modal">
      <ModalWrapper
        keepMounted
        onClose={handleClose}
        // @ts-ignore
        open={visibleBasketDialog}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <AddShippingAddress onClose={handleClose} />
      </ModalWrapper>
    </div>
  );
};
